import React, { useState, useEffect } from "react";
import { CaretLeft, CaretRight } from "phosphor-react";
import './TextCarousel.css';
const TextCarousel = ({ items, interval }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showText, setShowText] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      // Increment the index in a cyclic manner
      setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
      setShowText(false);
    }, interval);

    return () => {
      clearInterval(timer);
    };
  }, [items, interval]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? items.length - 1 : prevIndex - 1
    );
    setShowText(false); 
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === items.length - 1 ? 0 : prevIndex + 1
    );
    setShowText(false); 
  };

  useEffect(() => {
    const showTextTimeout = setTimeout(() => {
      setShowText(true);
    },300);

    return () => {
      clearTimeout(showTextTimeout);
    };
  }, [currentIndex]);


  return (
    <div className="text-carousel">
        <span><CaretLeft className="topnavbariconalign" onClick={handlePrev} size={15} /></span> &nbsp; &nbsp; &nbsp;
              <span  className={`carousel-text ${showText ? "show" : ""}`}>{items[currentIndex]}</span>
              &nbsp; &nbsp; &nbsp;
              <span><CaretRight className="topnavbariconalign" onClick={handleNext}  size={15} /> </span>
    </div>
  );
};

export default TextCarousel;
